export const WSB_MERCHANT_SOURCE = 'onecom_wsb';

export const GRAVITY_ACTIVATION_CLASS = 'gv-activated gv-h-full';

export const GRAVITY_DESIGN_APPS = [
  'calendar-v2-gsd',
  'services-v2',
  'settings-v2',
];
